export default __webpack_public_path__ + "static/media/remote_controlled_robots.e387107e.png";